/**
 * Государственные и муниципальные услуги в электронном виде, краткое описание
 */
import { Identity } from '@n3/ng-api-common';
import { EntityState } from '@n3/ng-api-common';
import { ClassifierShort } from '@n3/ng-api-common';
import { BaseModel } from '@n3/ng-api-base-kit';

export class PublicDigitalServiceShort extends BaseModel {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public identity: Identity; /**/
    public entity_state: EntityState; /**/
    public institution_identity: Identity; /**/
    public service: ClassifierShort; /**/
    public epgu_url: string; /*Ссылка на ЕПГУ*/
    public rpgu_url: string; /*Ссылка на РПГУ*/
    public documentation_url: string; /*Ссылка на порядок оказания услуги*/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super();

        this.identity = new Identity(json.identity);
        this.entity_state = new EntityState(json.entity_state);
        this.institution_identity = new Identity(json.institution_identity);
        this.service = new ClassifierShort(json.service);
        this.epgu_url = json.epgu_url || null;
        this.rpgu_url = json.rpgu_url || null;
        this.documentation_url = json.documentation_url || null;
        this._isEmpty = this.isEmpty(this);
    }
}
